// Tier 1 = homepage primary; Tier 2 = services page secondary; Tier 3 = mention only
export const SERVICES = [
  {
    slug: "instalasi-perbaikan-listrik",
    title: "Instalasi & Perbaikan Listrik",
    tier: 1,
    icon: "zap",
    short:
      "Instalasi baru & perbaikan darurat untuk rumah, ruko, dan industri — standar PUIL 2011 & SNI.",
    long:
      "Kami menangani instalasi listrik baru, perbaikan korsleting, MCB sering jeglek, stop kontak terbakar, hingga penggantian kabel. Tim teknisi kami siap 24/7 untuk kasus darurat dan selalu membawa alat ukur profesional (megger, tang ampere, thermal gun).",
    features: [
      "Instalasi baru rumah & ruko",
      "Perbaikan darurat 24/7",
      "Kabel SNI & MCB bermerek",
      "Sertifikat Layak Operasi (SLO)",
    ],
    keywords: ["jasa listrik batam", "instalasi listrik batam", "teknisi listrik batam"],
  },
  {
    slug: "service-ac",
    title: "Service AC",
    tier: 1,
    icon: "snowflake",
    short:
      "Cuci AC, isi freon, perbaikan AC tidak dingin, bongkar pasang AC — rumah, kantor, dan komersial.",
    long:
      "Layanan AC lengkap: cuci AC rutin, isi freon R32/R410A, diagnosa AC tidak dingin, perbaikan kompresor, hingga bongkar pasang saat pindah rumah. Kami bersihkan sampai ke bagian evaporator dan drain untuk hasil dingin maksimal.",
    features: [
      "Cuci AC (split, cassette, standing)",
      "Isi freon R32 / R410A",
      "AC tidak dingin / bocor",
      "Bongkar pasang pindah unit",
    ],
    keywords: ["service ac batam", "cuci ac batam", "isi freon batam"],
  },
  {
    slug: "instalasi-cctv",
    title: "Instalasi CCTV",
    tier: 1,
    icon: "camera",
    short:
      "Pemasangan CCTV untuk rumah, toko, dan kantor — sistem rekam, remote view, dan integrasi alarm.",
    long:
      "Kami merancang dan memasang sistem CCTV yang pas dengan kebutuhan Anda: IP/Analog, 2MP sampai 8MP, night vision, remote view lewat HP, hingga integrasi alarm. Setelah terpasang kami latih Anda mengoperasikannya.",
    features: [
      "Rumah pribadi & kos",
      "Toko / ritel / UMKM",
      "Kantor & ruko",
      "Remote view via smartphone",
    ],
    keywords: ["instalasi cctv batam", "pasang cctv batam", "cctv rumah batam"],
  },
  {
    slug: "panel-industri",
    title: "Panel & Industri",
    tier: 1,
    icon: "cpu",
    short:
      "Panel MDB, SDB, MCC, ATS-AMF, capacitor bank — lengkap dengan commissioning di lokasi.",
    long:
      "Kami merakit panel listrik custom untuk industri dan komersial: MDB, SDB, panel kontrol motor (DOL, Star-Delta, VSD), panel ATS-AMF untuk genset, hingga panel synchronizing. Semua diuji FAT sebelum dikirim dan tersedia commissioning on-site.",
    features: [
      "Panel MDB / SDB / MCC",
      "ATS-AMF untuk genset",
      "Capacitor bank & PFI",
      "FAT & commissioning",
    ],
    keywords: ["panel listrik batam", "jasa listrik pabrik batam", "teknisi listrik industri batam"],
  },

  // Tier 2 — Services page & SEO
  {
    slug: "service-mesin-cuci",
    title: "Service Mesin Cuci",
    tier: 2,
    icon: "washing-machine",
    short:
      "Perbaikan mesin cuci yang tidak berputar, error, bocor, atau tidak mengeluarkan air.",
    long:
      "Kami service mesin cuci front loading dan top loading semua merek. Diagnosa motor, gearbox, timer, sensor water level, dan drain pump. Part pengganti original tersedia untuk merek populer.",
    features: [
      "Tidak berputar / spin lemah",
      "Error code tampil di panel",
      "Bocor / tidak buang air",
      "Ganti belt, gearbox, sensor",
    ],
    keywords: ["service mesin cuci batam", "perbaikan mesin cuci batam"],
  },
  {
    slug: "service-kulkas",
    title: "Service Kulkas",
    tier: 2,
    icon: "refrigerator",
    short:
      "Kulkas tidak dingin, bocor, bunyi, atau mati total — kami diagnosa dan perbaiki di tempat.",
    long:
      "Service kulkas 1 pintu, 2 pintu, side-by-side, dan showcase. Pengisian freon, perbaikan kompresor, thermostat, kapasitor, hingga penggantian karet pintu. Layanan panggil ke lokasi tanpa perlu angkut kulkas Anda.",
    features: [
      "Tidak dingin / dingin lemah",
      "Bocor air / bunyi keras",
      "Ganti kompresor & thermostat",
      "Layanan panggil ke rumah",
    ],
    keywords: ["service kulkas batam", "perbaikan kulkas batam"],
  },
  {
    slug: "instalasi-water-heater",
    title: "Instalasi Water Heater",
    tier: 2,
    icon: "droplet",
    short:
      "Pemasangan water heater listrik / gas untuk rumah, kos, dan kontrakan — aman & rapi.",
    long:
      "Kami pasang water heater listrik instant, storage, dan water heater gas lengkap dengan pengkabelan MCB khusus, ELCB, grounding, dan pemipaan PPR. Juga tersedia service water heater yang bocor atau tidak panas.",
    features: [
      "Water heater listrik & gas",
      "Rumah tangga & kos-kosan",
      "MCB + ELCB khusus",
      "Pemipaan rapi & aman",
    ],
    keywords: ["instalasi water heater batam", "pasang water heater batam"],
  },

  // Tier 3 — Mention only
  {
    slug: "perbaikan-modul-pcb",
    title: "Perbaikan Modul PCB",
    tier: 3,
    icon: "circuit-board",
    short:
      "Perbaikan modul elektronik ringan & sistem kontrol dasar pada peralatan rumah tangga.",
    long:
      "Layanan tambahan: perbaikan modul PCB elektronik ringan pada mesin cuci, kulkas, dispenser, dan sistem kontrol dasar (mikrokontroler, relay board). Kami sarankan konsultasi dulu via WhatsApp untuk cek kelayakan.",
    features: [
      "Modul PCB mesin cuci / kulkas",
      "Kontrol dasar (relay / timer)",
      "Cek kelayakan sebelum perbaikan",
    ],
    keywords: ["perbaikan modul pcb batam", "elektronik ringan batam"],
  },
];

export const PRIMARY_SERVICES = SERVICES.filter((s) => s.tier === 1);
export const SECONDARY_SERVICES = SERVICES.filter((s) => s.tier === 2);
export const TERTIARY_SERVICES = SERVICES.filter((s) => s.tier === 3);
